import contractMgsConfs from './contract_mgs'
import contractitems from '../contractitems/subentities'
import sharesConfs from './shares'
import Validators from '../validators'
import moment from 'moment'
import * as defaultConst from '../../../constants/default_constants'

export default function _createSubentityConfs (store) {
  return {
    shares: store.createEmbededEntityState(sharesConfs(store)),
    rightsCosts: store.createEmbededEntityState(contractitems.rightsCostsConfs(store)),
    costs: store.createEmbededEntityState(contractitems.limitsAttrs(store)),
    contract_mgs: store.createEmbededEntityState(contractMgsConfs(store)),

    costs_total: store.createEmbededEntityState({
      attrs: ['platform', 'right_type', 'expense_type', 'costs_past_due_date', 'costs_before_due_date', 'costs_total'],
      titles: [store.__('platform'), store.__('right type'), store.__('expense type'), store.__('due'), store.__('before due'), store.__('total')],
      _sortField: 'platform, expense_type',
      validators: {}
    }),

    financial_reports: store.createEmbededEntityState({
      attrs: ['id', 'preview', 'client_id', 'month', 'year'],
      titles: [store.__('ID'), store.__('report'), store.__('client'), store.__('month'), store.__('year')],
      _sortField: 'id',
      noSort: ['preview'],
      validators: {}
    }),

    contract_payments: store.createEmbededEntityState({
      attrs: [
        'id', 'contractor_id', 'month', 'year', 'status', 'amount_to_be_paid',
        'amount_to_be_paid_calculated', 'wire_fee', 'withholding_tax_amount', 'pay_date',
        'amount_paid', 'amount_paid_including_vat', 'invoice_number', 'dwh_last_updated_at'
      ],
      titles: [
        store.__('id'), store.__('contractor'), store.__('month'), store.__('year'), store.__('status'), store.__('amount payable'),
        store.__('amount payable calculated'), store.__('wire fee'), store.__('withholding tax'), store.__('pay date'),
        store.__('transfer amount'), store.__('transfer amount (incl. VAT)'), store.__('invoice number'), store.__('DWH last update')
      ],
      _sortField: 'year,month,id',
      _sortDir: 'DESC,DESC,DESC',
      noSort: ['amount_to_be_paid_calculated'],
      initVals: (row) => ({
        control_timestamp: Math.round(new Date().getTime()),
        owner: store.loggedUser.email,
        status: 'new',
        // wire_fee: store.cv.record.has('payment_wire_fee') ? store.cv.record.get('payment_wire_fee') : null,
        updated_at: moment().format(),
        year: moment().format('YYYY'),
        contractor_id: ((store.cv.record.has('contractors_from_shares') && store.cv.record.get('contractors_from_shares')) || [])
          .concat((store.cv.record.has('shares') && store.cv.record.get('shares')) || [])
          .filter(i => !(defaultConst.BLUESKY_CONTRACTOR_IDS).includes(i.contractor_id))
          .map(i => parseInt(i.contractor_id)).shift()
      }),
      onFieldChange: {
        amount_to_be_paid: (val, state) => {
          // wire fee automatically
          const isWireFee = !(!state.record.has('wire_fee') || !state.record.get('wire_fee'))
          const contractWireFee = store.cv.record.has('payment_wire_fee') ? store.cv.record.get('payment_wire_fee') : null
          if (!isWireFee && val && val > 0) {
            state.record.set('wire_fee', contractWireFee)
          }
          // withholding tax automatically
          const contractorSelected = state.record.has('contractor_id') && state.record.get('contractor_id') &&
              store.options.get('clients').find(i => i.id === state.record.get('contractor_id'))
          if (contractorSelected) {
            const wTax = (parseFloat(contractorSelected.withholding_tax || 0).toFixed(6) / 100 * parseFloat(val)).toFixed(2)
            state.record.set('withholding_tax_amount', wTax)
          }
          // status update
          if (!state.record.has('status') || !state.record.get('status') || ['new', '', null].includes(state.record.get('status'))) {
            state.record.set('status', 'in_processing')
          }
        },
        pay_date: (val, state) => {
          const payDate = val && moment(val).isValid() && moment(val)
          if (payDate && payDate.isAfter(moment(), 'day')) {
            state.record.set('status', 'waiting')
          } else if (payDate && payDate.isSameOrBefore(moment(), 'day')) {
            state.record.set('status', 'paid')
          }
          // transfer amount automatically
          const isAmountPaid = !(!state.record.has('amount_paid') || !state.record.get('amount_paid'))
          const amountToPaid = state.record.has('amount_to_be_paid') ? state.record.get('amount_to_be_paid') : 0
          const wireFee = state.record.has('wire_fee') ? state.record.get('wire_fee') : 0
          const withholdingTax = state.record.has('withholding_tax_amount') ? state.record.get('withholding_tax_amount') : 0
          const amountPaid = (parseFloat(amountToPaid || 0) - parseFloat(wireFee || 0) - parseFloat(withholdingTax || 0))
          const contractorSelected = state.record.has('contractor_id') && state.record.get('contractor_id') &&
              store.options.get('clients').find(i => i.id === state.record.get('contractor_id'))
          const vatRate = state.record.has('vat_amount') && state.record.get('vat_amount')
            ? state.record.get('vat_amount')
            : (parseFloat(contractorSelected.vat_rate).toFixed(6) / 100 * parseFloat(amountPaid))

          if (!isAmountPaid && val && amountPaid && amountPaid > 0) {
            state.record.set('vat_amount', vatRate.toFixed(2))
            state.record.set('amount_paid', amountPaid.toFixed(2))
            state.record.set('amount_paid_including_vat', (parseFloat(amountPaid) + parseFloat(vatRate)).toFixed(2))
          }
        },
        amount_paid: (val, state) => {
          // vat rate automatically
          const isTaxRate = !(!state.record.has('vat_amount') || !state.record.get('vat_amount'))
          const contractorSelected = state.record.has('contractor_id') && state.record.get('contractor_id') &&
              store.options.get('clients').find(i => i.id === state.record.get('contractor_id'))
          if (contractorSelected && !isTaxRate) {
            state.record.set(
              'vat_amount',
              val === null || val === '' ? null
                : (parseFloat(contractorSelected.vat_rate).toFixed(6) / 100 * parseFloat(val)).toFixed(2)
            )
          }
          // status update
          if (!state.record.has('status') || !state.record.get('status') || ['new', '', null].includes(state.record.get('status'))) {
            state.record.set('status', 'in_processing')
          }
          // transfer amount automatically
          const amountPaid = state.record.has('amount_paid') ? state.record.get('amount_paid') : null
          const vatRate = state.record.has('vat_amount') ? state.record.get('vat_amount') : 0
          const result = parseFloat(amountPaid || 0) + parseFloat(vatRate || 0)
          state.record.set('amount_paid_including_vat', amountPaid === null || amountPaid === '' ? null : parseFloat(result).toFixed(2))
        },
        wire_fee: (val, state) => {
          if (!state.record.has('status') || !state.record.get('status') || ['new', '', null].includes(state.record.get('status'))) {
            state.record.set('status', 'in_processing')
          }
        },
        withholding_tax_amount: (val, state) => {
          if (!state.record.has('status') || !state.record.get('status') || ['new', '', null].includes(state.record.get('status'))) {
            state.record.set('status', 'in_processing')
          }
        },
        vat_amount: (val, state) => {
          const amountPaid = state.record.has('amount_paid') && state.record.get('amount_paid')
          if (amountPaid && amountPaid > 0) {
            state.record.set('amount_paid_including_vat', (parseFloat(amountPaid) + parseFloat(val || 0)).toFixed(2))
          }
          // status update
          if (!state.record.has('status') || !state.record.get('status') || ['new', '', null].includes(state.record.get('status'))) {
            state.record.set('status', 'in_processing')
          }
        },
        status: (val, state) => {
          const paymentWireFee = store.cv.record && store.cv.record.has('payment_wire_fee') && store.cv.record.get('payment_wire_fee')
          const wireFee = state.record.has('wire_fee') && state.record.get('wire_fee') && state.record.get('wire_fee').length > 0
          // set "wire_fee" if "in_processing" status
          if (val === 'in_processing' && !wireFee) {
            state.record.set('wire_fee', parseFloat(paymentWireFee || 0).toFixed(2))
          }
        }
      },
      validators: {
        amount_to_be_paid: Validators.isMandatory(store),
        contractor_id: Validators.isMandatory(store),
        month: [Validators.isMandatory(store), Validators.isMonth(store)],
        status: Validators.isMandatory(store),
        year: [Validators.isMandatory(store), Validators.isYear(store)],
        _global: (vals) => {
          vals.set('updated_at', moment().format())
          const payStatus = vals.has('status') && vals.get('status')
          const payDate = vals.has('pay_date') && vals.get('pay_date') &&
            moment(vals.get('pay_date')).isValid() && moment(vals.get('pay_date'))
          const amountToBe = vals.has('amount_to_be_paid') && vals.get('amount_to_be_paid')
          const amountWithVat = vals.has('amount_paid_including_vat') && vals.get('amount_paid_including_vat')
          const amountPaid = vals.has('amount_paid') && vals.get('amount_paid')

          if (payDate && payDate.isAfter(moment(), 'day') &&
          payStatus && payStatus !== 'waiting') {
            return [store.__('If the Pay date is in the future, set Status to "Waiting".')]
          } else if (payDate && payDate.isSameOrBefore(moment(), 'day') &&
          payStatus && payStatus !== 'paid') {
            return [store.__('If the Pay date is in the past, set Status to "Paid".')]
          } else if (!payDate && (payStatus === 'paid' || payStatus === 'waiting')) {
            return [store.__('"Pay date" is missing.')]
          }

          if (payStatus === 'waiting' && (!amountToBe || !amountPaid)) {
            return [store.__('If the status is "Waiting" set both values: Amount payable & Transfer amount')]
          } else if (payStatus === 'paid' && (!amountToBe || !amountPaid)) {
            return [store.__('If the status is "Wait" set both values: Amount payable & Transfer amount')]
          } else if (payStatus === 'postponed' && (!amountToBe)) {
            return [store.__('If the status is "Postponed" set value: Amount payable')]
          }

          if (amountWithVat && amountWithVat > 0 && !amountPaid) {
            return [store.__('"Transfer amount" is missing. Click the button to recalculate transfer amount.')]
          } else if (amountPaid && amountPaid > 0 && !amountWithVat) {
            return [store.__('"Transfer amount (including VAT)" is missing. Click the button to recalculate transfer amount.')]
          }
        }
      }
    })
  }
}
